const config = () => {
  return {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  };
};

// console.log(config, "render");
module.exports = { config };
